import React from "react";
import styles from "./RequestCart.module.scss";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { Tooltip } from "antd";
import CalendarIcon from "../../assets/icons/CalendarIcon";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../contexts/ThemeContext";
import BasicRangeShortcuts from "../DatePicker/DatePicker";

const data = [
  { name: "2021-11-01", uv: 0, pv: 0, amt: 0 },
  { name: "2021-11-02", uv: 0, pv: 0, amt: 0 },
  { name: "2021-11-03", uv: 1, pv: 2, amt: 2 },
  { name: "2021-11-04", uv: 0, pv: 0, amt: 0 },
  { name: "2021-11-05", uv: 0, pv: 0, amt: 0 },
  { name: "2021-11-06", uv: 3, pv: 2, amt: 3 },
  { name: "2021-11-07", uv: 0, pv: 0, amt: 0 },
  { name: "2021-11-09", uv: 2, pv: 4, amt: 1 },
  { name: "2021-11-11", uv: 3, pv: 1, amt: 4 },
  { name: "2021-11-09", uv: 2, pv: 4, amt: 1 },
  { name: "2021-11-10", uv: 0, pv: 0, amt: 0 },
  { name: "2021-11-12", uv: 0, pv: 0, amt: 0 },
];

const RequestCart = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <section className={styles.requestCartSection}>
      <div className={styles.chartHeader}>
        <div className={styles.headerLeft}>
          <h2 className={styles.chartTitle}>{t("requestStats")}</h2>
          <p className={styles.chartDate}>01.11.2021 - 30.11.2021</p>
          {/* <BasicRangeShortcuts /> */}
        </div>
        <button className={styles.calendarButton}>
          <CalendarIcon theme={theme} />
        </button>
      </div>
      <ResponsiveContainer minHeight={225} maxHeight={225}>
        <BarChart
          width={500}
          maxHeight={225}
          minHeight={225}
          data={data}
          barCategoryGap={35}
          margin={{ bottom: 45 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="name"
            angle={-65}
            dy={30}
            tick={{ fontSize: 12, fill: "#80828B" }}
          />
          <YAxis />
          <Tooltip />
          <Bar
            maxBarSize={10}
            radius={52}
            dataKey="pv"
            stackId="a"
            fill="#36CAEB"
          />

          <Bar
            maxBarSize={10}
            radius={52}
            dataKey="uv"
            stackId="a"
            fill="#1F995E"
          />
          <Bar
            maxBarSize={10}
            radius={52}
            dataKey="amt"
            stackId="a"
            fill="#FAB031"
          />
        </BarChart>
      </ResponsiveContainer>
      <div className={styles.chartFooter}>
        {t("statsMoreInfo")} {"  >"}
      </div>
    </section>
  );
};

export default RequestCart;
